import React from 'react';
import { PlmgButton } from '@ducky/plumage-react';
import { ButtonWrapper } from './elements';
import ToolTip01 from 'dc/ToolTip01';

type LeaderboardTitle = {
  readonly text: string;
};

export function InfoIconTooltip({
  text,
}: LeaderboardTitle): React.ReactElement {
  return (
    <ToolTip01 placement="top" alignment="left" text={text}>
      <ButtonWrapper>
        <PlmgButton
          size="small"
          color="primary"
          iconCenter="info"
          design="borderless"
        />
      </ButtonWrapper>
    </ToolTip01>
  );
}
